import React, { useState } from 'react';

import '../pages.scss';
import Logo from '../../components/logo.mjs';
import Snackbar from '../../components/snackbar.mjs'


const AdditionalLivestreams = () => {
  const keygenID = sessionStorage.getItem('keygenID');
  const keygenToken = sessionStorage.getItem('userToken');

  const [uID, setUID] = useState('');

  let remoteStream = null;
  var streamStatus = "Inactive";
  const servers = {
    iceServers: [
      {
        urls: ['stun:stun1.l.google.com:19302', 'stun:stun2.l.google.com:19302'],
      },
    ],
    iceCandidatePoolSize: 10,
  };

  const pc = new RTCPeerConnection(servers);

  const makeFullScreen = () => {
    const elem = document.getElementById("local-video");
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen();
    }
  }

  const handleSubmit = () => {
    startLivestreamWithLog();
  }

  const startLivestreamWithLog = async () => {
    const startLivestream = async () => {
        console.log(streamStatus);
        
      if (streamStatus !== "Inactive") {
        return;
      }

      streamStatus = "Starting";

      Snackbar("startSnackbar", 10000);

      var offer;
      await fetch("/generateOffer/" + keygenID + "/" + keygenToken + "/?add=" + uID)
      .then(response => response.json())
      .then(data => {
          offer = data;
      })
      .catch(error => console.log(error));

      remoteStream = new MediaStream();

      pc.ontrack = (event) => {
        event.streams[0].getTracks().forEach((track) => {
          remoteStream.addTrack(track);
        });
      };

      // Print for testing purposes
      pc.ondatachannel = e => {
          const receiveChannel = e.channel;
          receiveChannel.onmessage = e =>  console.log("Message received on channel: "  + e.data );
          receiveChannel.onopen = e => console.log("The channel is open.");
          receiveChannel.onclose = e => console.log("The channel is closed.");
          pc.channel = receiveChannel;
      }
        
      await pc.setRemoteDescription(offer);

      const answer = await pc.createAnswer();
      await pc.setLocalDescription(answer);

      document.getElementById("local-video").srcObject = remoteStream;
      fetch("/answer/" + keygenID + "/" + keygenToken + "/", {
        method: 'POST',
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          
        },
        body: JSON.stringify(pc.localDescription)
      }).catch(error => console.log(error));
      streamStatus = "Active";
    }

    await startLivestream();
  }
    return (
      <div className="page" id="liveStreamPage">
        <div className="successSnackbar" id="startSnackbar">Trying to connect to the server, this could take a second.</div>
        {Logo()}
        <h1><b>Watch what's happening!</b></h1>
        <div class="video-player">
          <video class="video" id="local-video" muted autoPlay></video>
          <input class="video-content" type="image" alt="Expand Video" src="../assets/expand-icon.png" onClick={makeFullScreen} />
        </div>
        <br></br>
        <form onSubmit={handleSubmit}>
            <label><b>User ID: </b></label>
            <input type="text" onChange={(e) => setUID(e.target.value)} required></input>
            <br/><br/>
            <input type="submit" value="View Livestream"></input>
        </form>
    </div>
    )
}

export default AdditionalLivestreams;